import React, { Component } from 'react';
import PropTypes from 'prop-types';
//Opentok
import { OTPublisher } from 'opentok-react';
import { myLog } from '../../../../utils/Utility';
import store from '../../../../sessionStorage';
// import BG_IMAGE from '../../../../utils/images/Bloomifai Light Logo.jpeg';
import BudImage from '../../../../utils/images/Bud.png';
import BroadCastSubscribers from './BroadCastSubscribers';
import { Doctor, LevelTwoAdmin, Student, Tutor } from '../../../../utils/common/NamingTerms';
import { RESPONSE_CONSTANT } from '../../../../utils/ResponseConstant';
import ScreenShotEditModal from './ScreenShotEditModal';
import { emitLiveCaption, emitStreamId } from '../../../action/SocketActions';
import LanguageContext, { LanguageProvider } from '../../../../utils/common/LanguageContext';
import AppConfig from '../../../../utils/common/DomainConfiguration';

// Active-speaker detection for the local publisher (in-person sessions only).
// Mirrors the tuning used for remote participants in ParticipantContent.
// Smoothed (logarithmic) audio level above which the host is treated as speaking.
const SELF_SPEAKING_THRESHOLD = 0.2;
// Keep the highlight on briefly after audio drops so it does not flicker between words.
const SELF_SPEAKING_OFF_DELAY = 600;

// Higher-Order Component to inject translation function with ref forwarding
const withLanguage = (WrappedComponent) => {
    class WithLanguage extends Component {
        render() {
            const { forwardedRef, ...rest } = this.props;
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...rest} t={t} ref={forwardedRef} />}
                </LanguageContext.Consumer>
            );
        }
    }

    return React.forwardRef((props, ref) => {
        return <WithLanguage {...props} forwardedRef={ref} />;
    });
};

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class OpentokPublisher extends Component {
    static propTypes = {
        session: PropTypes.any,
    };

    constructor(props) {
        super(props);

        // const visitType = store.get('VISIT_TYPE');
        // const sessionType = sessionStorage.getItem('SESSION_TYPE');
        // const isInPersonOneToOne = visitType === 'one_to_one' && sessionType === 'IN_PERSON';
        this.publisherOptions = {
            insertMode: 'append',
            // When this connection is also publishing a screen share the uplink
            // is shared between two video streams plus the microphone. Let the
            // SDK drop our camera video first so the voice keeps its bandwidth
            // instead of breaking up.
            audioFallback: { publisher: true, subscriber: true },
            height:
                store.get('VISIT_TYPE') !== 'broadcast' ||
                (store.get('VISIT_TYPE') === 'broadcast' && this.props.role === LevelTwoAdmin)
                    ? '150'
                    : '100%',
            width:
                store.get('VISIT_TYPE') !== 'broadcast' ||
                (store.get('VISIT_TYPE') === 'broadcast' && this.props.role === LevelTwoAdmin)
                    ? '150'
                    : '100%',
            showControls: true,
            event: {},
            style: {
                archiveStatusDisplayMode: 'off',
                nameDisplayMode: 'off',
                buttonDisplayMode: 'off',
                videoDisabledDisplayMode: 'off',
            },
            name:
                store.get('userSession')?.role === Tutor
                    ? (
                          store.get('VISIT_TYPE') === 'class_room' ||
                          store.get('VISIT_TYPE') === 'class_room_session' ||
                          store.get('VISIT_TYPE') === 'conference_call'
                      )
                        ? store.get('userSession')?.name
                        : 'Educator'
                    : store.get('insAdminSession')?.role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN
                      ? store.get('insAdminSession')?.name
                      : store.get('anonymousUser')
                        ? store.get('anonymousUser')
                        : store.get('userSession')?.name,
            userId: this.props.userId,
            publishAudio: false,
            publishVideo: false,
            // publishVideo: !isInPersonOneToOne,
        };
        this.publisherOptionscreen = {
            insertMode: 'append',
            height: 150,
            width: 150,
            event: {},
            videoSource: 'screen',
            // Ensure screen share never publishes its own audio; rely on
            // the main publisher's audio so the mic mute button stays
            // in sync with what others hear.
            publishAudio: false,
            // Capturing a full desktop at its native resolution and frame rate
            // saturates the uplink and starves the microphone stream, which the
            // other participants hear as the speaker's voice breaking up.
            // A shared screen needs detail, not motion smoothness, so cap both.
            videoContentHint: 'detail',
            frameRate: 7,
            maxResolution: { width: 1920, height: 1080 },
            style: {
                archiveStatusDisplayMode: 'off',
                nameDisplayMode: 'off',
                buttonDisplayMode: 'off',
                videoDisabledDisplayMode: 'off',
            },
            name: 'screen',
        };
        this.state = {
            caption: null,
            event: null,
            screenShare: false,
            muteVideoStatus: true,
            showCallBack: 0,
            emittedStreamIds: new Set(),
            speechRecognition: null,
            isListening: false,
            speechBuffer: '',
            lastSpeechTime: null,
            // controls whether SpeechRecognition is allowed to (re)start
            isRecognitionAllowed: true,
            isPublisherReady: false,
            // User-selected background blur; applied whenever the camera is on.
            backgroundBlur: false,
            // Track current audio mute state (defaults to muted)
            isAudioMuted: true,
            // True while the host is speaking with the mic unmuted (in-person sessions).
            isSelfSpeaking: false,
        };
        // Moving average of our own publisher audio level.
        this.selfAudioAverage = null;
        // Timer that turns the speaking highlight off after a pause.
        this.selfSpeakingOffTimer = null;
    }

    componentDidMount() {
        const { sessionHelper } = this.props;
        sessionHelper.session.on('signal:raiseHand', (event) => {
            const { data } = event;
            const { raiseHand, streamId } = JSON.parse(data);
            if (streamId === undefined) {
                return;
            }
            if (raiseHand) {
                this.setState((prevState) => ({
                    raisedHands: new Set(prevState.raisedHands).add(streamId),
                }));
            } else {
                this.setState((prevState) => {
                    const newRaisedHands = new Set(prevState.raisedHands);
                    newRaisedHands.delete(streamId);
                    return { raisedHands: newRaisedHands };
                });
            }
        });

        // NEW: Listen for requests to announce our streamId mapping.
        // This is the deterministic replacement for name-matching guesswork.
        // Whenever anyone (re)joins, they broadcast requestStreamIds and we respond
        // with OUR OWN authoritative mapping - no guessing needed.
        sessionHelper.session.on('signal:requestStreamIds', (event) => {
            const currentConnectionId = sessionHelper?.session?.connection?.connectionId;
            if (
                event.from?.connectionId &&
                currentConnectionId &&
                event.from.connectionId === currentConnectionId
            ) {
                return; // Ignore our own request
            }
            // console.log('[Publisher] Received requestStreamIds signal - announcing our mapping');
            this.emitMyStreamId();
        });

        // In-person sessions only: log the authoritative hasAudio flip. The SDK
        // updates stream.hasAudio asynchronously after publishAudio(), and this is
        // the event where it actually changes.
        this.hasAudioPropertyHandler = (event) => {
            // Gate at fire time, not mount time - VISIT_TYPE/SESSION_TYPE may land
            // in storage after this component mounts.
            if (!this.isInPersonSession() || event?.changedProperty !== 'hasAudio') {
                return;
            }
            const myStreamId = this.state.event?.stream?.id;
            const streamId = event?.stream?.id;
            console.log('[InPerson][hasAudio]', {
                source: streamId && streamId === myStreamId ? 'self (YOU)' : 'remote',
                streamName: event?.stream?.name,
                streamId,
                hasAudio: event?.newValue,
                at: new Date().toISOString(),
            });
        };
        sessionHelper.session.on('streamPropertyChanged', this.hasAudioPropertyHandler);

        // Start long-session monitoring for speech recognition
        this.startSessionMonitoring();
    }

    // Monitor long sessions and perform periodic cleanup
    startSessionMonitoring = () => {
        // Clean up speech recognition state every 5 minutes for long sessions
        this.sessionMonitorInterval = setInterval(() => {
            if (this.isInPersonSession() && this.state.speechRecognition) {
                // Force garbage collection of old speech buffer references
                if (this.state.speechBuffer && this.state.speechBuffer.length > 1000) {
                    this.setState({ speechBuffer: '' });
                }

                // Reset any stale timeout references
                if (this.speechBufferTimeout) {
                    clearTimeout(this.speechBufferTimeout);
                    this.speechBufferTimeout = null;
                }
            }
        }, 300000); // Every 5 minutes
    };

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.event && this.state.event) {
            // Event became available - component ready for speech recognition
        }
    }

    // componentWillMount
    componentWillMount() {
        console.log('OpentokPublisher: componentWillMount - about to invoke isInitialCallLoader', {
            hasCallback: typeof this.props.isInitialCallLoader === 'function',
            isOneToOne: this.props.isOneToOne,
            isClassRoom: this.props.isClassRoom,
        });

        if (typeof this.props.isInitialCallLoader === 'function') {
            this.props.isInitialCallLoader();
        }
    }

    // componentWillUnmount - cleanup
    componentWillUnmount() {
        if (this.captionTimeout) {
            clearTimeout(this.captionTimeout);
        }

        if (this.captionPollInterval) {
            clearInterval(this.captionPollInterval);
        }

        // Clean up session monitoring
        if (this.sessionMonitorInterval) {
            clearInterval(this.sessionMonitorInterval);
        }

        // Stop speech recognition
        this.stopSpeechRecognition();
        this.speechRecognitionRef = null;

        // Clear speech buffer timeout
        if (this.speechBufferTimeout) {
            clearTimeout(this.speechBufferTimeout);
        }

        // Clear the local speaking highlight timer
        if (this.selfSpeakingOffTimer) {
            clearTimeout(this.selfSpeakingOffTimer);
            this.selfSpeakingOffTimer = null;
        }

        // Detach the in-person hasAudio logger
        const loggedSession = this.props.sessionHelper?.session;
        if (this.hasAudioPropertyHandler && typeof loggedSession?.off === 'function') {
            loggedSession.off('streamPropertyChanged', this.hasAudioPropertyHandler);
        }
        this.hasAudioPropertyHandler = null;

        // Reset caption-related state for clean re-initialization
        this.setState({
            event: null,
            speechBuffer: '',
            lastSpeechTime: null,
        });
    }

    // Method to start publishing captions
    startPublishingCaptions = () => {
        const { event } = this.state;
        if (event && event.target) {
            event.target.publishCaptions(true);
        }
    };

    // Method to stop publishing captions
    stopPublishingCaptions = () => {
        const { event } = this.state;
        if (event && event.target) {
            event.target.publishCaptions(false);
        }
    };

    // Method to ensure caption publishing is enabled after stream creation
    ensureCaptionPublishing = () => {
        const { event } = this.state;
        if (event && event.target) {
            event.target.publishCaptions(true);
        }
    };

    sendRaiseHandSignal = (raiseHand, streamId) => {
        const { session } = this.props;
        session.signal(
            {
                type: 'raiseHand',
                data: JSON.stringify({ raiseHand, streamId }),
            },
            (error) => {
                if (error) {
                    console.error('Error sending signal:', error);
                } else {
                    // console.log('Signal sent successfully');
                }
            }
        );
    };

    onRaiseHand = (raiseHand, callback) => {
        const { event } = this.state;
        if (event && event.target) {
            const streamId = event.stream.id;
            this.sendRaiseHandSignal(raiseHand, streamId);
            callback(true);
        } else {
            callback(false);
        }
    };

    //onMuteVideo
    onMuteVideo = (muteVideo, callback) => {
        const { event, isPublisherReady } = this.state;

        // 🚫 block early mute
        if (!isPublisherReady) {
            callback(false);
            return;
        }

        if (event && event.target) {
            event.target.publishVideo(muteVideo);

            // Camera turned on: make the outgoing video match this user's blur choice.
            if (muteVideo) {
                this.syncBackgroundBlur(event.target, { retry: true }).catch((error) => {
                    myLog('syncBackgroundBlur failed', error);
                });
            }

            if (this.props.isClassRoom || this.props.sessionTypeParamsGroup) {
                this.props.muteVideoStudent(false);
            }

            callback(true);
            myLog('event.target.publishVideo(muteVideo', event.target.publishVideo(muteVideo));
        } else {
            callback(false);
        }
    };

    // Bring this publisher's filter in line with `enable` (defaults to the user's
    // current choice). Only touches the local publisher, never other participants.
    syncBackgroundBlur = (publisher, { enable = this.state.backgroundBlur, retry = false } = {}) => {
        const hasBlur = publisher.getVideoFilter?.()?.type === 'backgroundBlur';
        if (enable === hasBlur) {
            return Promise.resolve();
        }
        const apply = () =>
            enable
                ? publisher.applyVideoFilter({ type: 'backgroundBlur', blurStrength: 'high' })
                : publisher.clearVideoFilter();
        // Right after publishVideo(true) the camera track may not be live yet.
        return apply().catch((error) =>
            retry
                ? new Promise((resolve) => setTimeout(resolve, 1000)).then(apply)
                : Promise.reject(error)
        );
    };

    // onToggleBackgroundBlur
    onToggleBackgroundBlur = (enable, callback) => {
        const publisher = this.state.event?.target;
        const previous = this.state.backgroundBlur;
        this.setState({ backgroundBlur: enable });

        // Publisher not up yet: keep the choice, it is applied when the camera turns on.
        if (!publisher) {
            callback(true);
            return;
        }

        // Camera off: removing a filter is safe now; adding one waits for the camera.
        if (!publisher.stream?.hasVideo) {
            if (!enable) {
                this.syncBackgroundBlur(publisher, { enable }).catch((error) => {
                    myLog('clear background blur failed', error);
                });
            }
            callback(true);
            return;
        }

        this.syncBackgroundBlur(publisher, { enable })
            .then(() => callback(true))
            .catch((error) => {
                myLog('onToggleBackgroundBlur failed', error);
                this.setState({ backgroundBlur: previous });
                callback(false);
            });
    };

    // onMuteAudio
    onMuteAudio = (muteVoice, callback) => {
        const { event } = this.state;
        if (
            event &&
            typeof event !== 'undefined' &&
            typeof event !== 'undefined' &&
            event.target !== 'null'
        ) {
            event.target.publishAudio(muteVoice);
            // Update audio mute state (muteVoice=true means audio is unmuted, muteVoice=false means muted)
            this.setState({ isAudioMuted: !muteVoice });
            
            if (this.props.isClassRoom || this.props.sessionTypeParamsGroup) {
                this.props.muteForceStudent(false);
            }
            // In in-person sessions, tie speech recognition to mute state
            if (this.isInPersonSession()) {
                // Log hasAudio around every mute/unmute. `before` is the value the
                // SDK still reports at click time; `after` is read on the next tick,
                // once publishAudio() has been applied to the stream.
                const myStream = event.stream;
                console.log('[InPerson][mute toggle]', {
                    action: muteVoice ? 'UNMUTE' : 'MUTE',
                    publishAudio: muteVoice,
                    hasAudioBefore: myStream?.hasAudio,
                    streamId: myStream?.id,
                    at: new Date().toISOString(),
                });
                setTimeout(() => {
                    console.log('[InPerson][mute toggle] hasAudioAfter', {
                        action: muteVoice ? 'UNMUTE' : 'MUTE',
                        hasAudio: myStream?.hasAudio,
                        isAudioMuted: this.state.isAudioMuted,
                        streamId: myStream?.id,
                    });
                }, 0);

                if (muteVoice === false) {
                    // Mic muted in OpenTok - stop listening for captions and drop
                    // the speaking highlight immediately.
                    this.clearSelfSpeaking();
                    this.setState({ isRecognitionAllowed: false }, () => {
                        this.stopSpeechRecognition();
                    });
                } else {
                    // Mic unmuted - allow recognition again and (re)start
                    this.setState({ isRecognitionAllowed: true }, () => {
                        if (!this.speechRecognitionRef && !this.state.speechRecognition) {
                            this.initializeSpeechRecognition();
                        }
                        this.startSpeechRecognition();
                    });
                }
            }
            callback(true);
            myLog('event.target.publishVideo(muteVideo', event.target.publishAudio(muteVoice));
        } else {
            // No publisher stream yet, so the click cannot be honoured. The button
            // rolls back and the caller shows "connection is getting established" -
            // log why, because until now this was indistinguishable from a publisher
            // that had failed outright and would never recover.
            console.warn('[OpenTok][mute rejected] publisher has no stream', {
                visitId: this.props.visitId,
                requested: muteVoice ? 'UNMUTE' : 'MUTE',
                hasSession: !!this.props.session,
                sessionConnected: !!this.props.session?.isConnected?.(),
            });
            callback(false);
        }
    };

    //onscreenShare
    onscreenShare = (callback) => {
        this.setState({ screenShare: !this.state.screenShare });
        callback(true);
    };

    // cancelScreenshare
    cancelScreenshare(value) {
        this.props.cancelScreenshare(value);
    }

    //onScreenShot
    onScreenShot() {
        const { event } = this.state;
        if (event) {
            return event.target.getImgData();
        }
    }

    //publisherEventHandlers
    publisherEventHandlers = {
        audioLevelUpdated: (event) => {
            this.handleSelfAudioLevel(event?.audioLevel);
        },
        captionReceived: (event) => {
            // Handle captions generated by this publisher
            this.handleCaptionReceived(event);
        },
        streamCreated: (event) => {
            this.setState({ event, isPublisherReady: false });
            console.log('[OpenTok Connected][Publisher streamCreated]', {
                visitId: this.props.visitId,
                userType: this.props.userType,
                role: this.props.role,
                credentialSource: this.props.credentialSource || 'unknown',
                hasStreamId: !!event?.stream?.id,
                hasConnectionId: !!event?.stream?.connection?.id,
                streamVideoType: event?.stream?.videoType || 'camera',
                sessionTypeParamsGroup: !!this.props.sessionTypeParamsGroup,
                isOneToOne: !!this.props.isOneToOne,
            });
            if (this.publisherReadyTimeout) {
                clearTimeout(this.publisherReadyTimeout);
            }

            this.publisherReadyTimeout = setTimeout(() => {
                this.setState({ isPublisherReady: true });
            }, 1500);
            const visitType = store.get('VISIT_TYPE');
            const sessionType = sessionStorage.getItem('SESSION_TYPE');
            const isInPersonOneToOne = visitType === 'one_to_one' && sessionType === 'IN_PERSON';
            setTimeout(() => {
                this.ensureCaptionPublishing();
                if (isInPersonOneToOne) {
                    // Always build the recogniser up front. Whether it actually listens
                    // is decided solely by the mic button - the old `!isAudioMuted`
                    // branch here was dead code, since audio always starts muted.
                    this.initializeSpeechRecognition();
                }
            }, 500);

            // Emit stream ID intelligently:
            // 1. Check if we've detected other users (even if props not fully loaded)
            // 2. Check if this is a multi-user session type (group/conference)
            // 3. Check if there's a createdByUserId (someone invited us)
            // 4. Check if visitId exists (joining someone's session)
            const myUserId = this.getCurrentUserId();
            const sessionUsersCount = this.props.studentDetails?.sessionUsers?.filter(u => u.userId !== myUserId).length || 0;
            const externalUsersCount = this.props.studentDetails?.externalUsersDetails?.length || 0;
            const hasDetectedUsers = (sessionUsersCount + externalUsersCount) > 0;
            
            // Check for multi-user session indicators
            const urlParams = new URLSearchParams(window.location.search);
            const createdByUserId = urlParams.get('createdByUserId');
            const visitId = urlParams.get('visitId') || this.props.visitId;
            const isMultiUserSession = this.props.sessionTypeParamsGroup || 
                                      this.props.isClassRoom || 
                                      createdByUserId ||
                                      (visitId && visitId !== 'undefined'); // Joining someone's session
            
            // Emit if we've detected users OR this is clearly a multi-user session
            const shouldEmit = hasDetectedUsers || isMultiUserSession;
            
            if (shouldEmit) {
                // Add delay to ensure other participants have time to process rejoin event and be ready to receive
                // This prevents race condition where we emit before receivers are ready
                const emissionDelay = hasDetectedUsers ? 300 : 100; // Longer delay if users already detected (likely a rejoin)
                
                setTimeout(() => {
                    this.announceMyStreamId(event?.stream?.id);
                    
                    // console.log('[Publisher] Emitted streamId on streamCreated (delayed):', {
                    //     streamId: event?.stream?.id,
                    //     userId: this.getCurrentUserId(),
                    //     delay: emissionDelay,
                    //     reason: hasDetectedUsers ? 'detected_users' : 'multi_user_session',
                    //     indicators: {
                    //         hasDetectedUsers,
                    //         sessionTypeParamsGroup: !!this.props.sessionTypeParamsGroup,
                    //         isClassRoom: !!this.props.isClassRoom,
                    //         hasCreatedBy: !!createdByUserId,
                    //         hasVisitId: !!visitId
                    //     }
                    // });
                }, emissionDelay);
            } else {
                // console.log('[Publisher] Skipped streamId emission - waiting for confirmation this is multi-user', {
                //     streamId: event?.stream?.id,
                //     userId: this.getCurrentUserId(),
                // });
            }

            // NEW: Broadcast a request for everyone already in the room to re-announce
            // their streamId mappings to us. This replaces the fragile name-matching
            // path in ClassRoomSubscribers/Subscribers with deterministic, per-participant
            // self-announcement. Works regardless of join order or roster sync timing.
            if (this.props.session && typeof this.props.session.signal === 'function') {
                this.props.session.signal(
                    { type: 'requestStreamIds', data: '' },
                    (err) => {
                        if (err) {
                            console.warn('[Publisher] Failed to send requestStreamIds signal', err);
                        } else {
                            // console.log('[Publisher] Broadcast requestStreamIds - asking all participants to announce');
                        }
                    }
                );
            }

            if (this.props.isBroadCast) {
                // this.props.streamLayoutBroadCast(event.stream.id);
            }
            if (this.props.isClassRoom || this.props.sessionTypeParamsGroup) {
                this.props.session.on('signal:muteVideo', (signalEvent) => {
                    const { connectionId } = JSON.parse(signalEvent.data);
                    if (connectionId === event.stream?.connection?.id) {
                        if (
                            event &&
                            typeof event !== 'undefined' &&
                            typeof event !== 'undefined' &&
                            event.target !== 'null'
                        ) {
                            event.target.publishVideo(false);
                            this.props.muteVideoStudent(true);
                        }
                    }
                });
                this.props.session.on('signal:removeStudentStream', (signalEvent) => {
                    const { connectionId } = JSON.parse(signalEvent.data);
                    if (connectionId === event.stream?.connection?.id) {
                        if (
                            event &&
                            typeof event !== 'undefined' &&
                            typeof event !== 'undefined' &&
                            event.target !== 'null'
                        ) {
                            event.target.destroy();
                        }
                    }
                });
            }
        },
        streamDestroyed: () => {
            this.setState({ event: null, isPublisherReady: false });
            if (this.props.isClassRoom && this.props.userType === Student) {
                this.props.navigateToSummary();
            }
            myLog('Publisher stream destroyed!');
        },
        accessDenied: () => {
            console.error('[OpenTok ERROR][publisher accessDenied]', {
                visitId: this.props.visitId,
                hint: 'Camera/microphone permission was denied - the publisher will never create a stream, so mute/unmute will keep failing.',
            });
        },
        muteForced: () => {
            this.props.muteForceStudent(true);
        },
    };

    // OT.initPublisher() / session.publish() failures were previously swallowed by
    // opentok-react, which is why a publisher that never comes up only surfaced as a
    // generic "connection is getting established" toast on every mute click.
    handlePublisherError = (error) => {
        console.error('[OpenTok ERROR][publisher failed]', {
            visitId: this.props.visitId,
            userType: this.props.userType,
            role: this.props.role,
            credentialSource: this.props.credentialSource || 'unknown',
            name: error?.name,
            code: error?.code,
            message: error?.message,
        });
    };

    handlePublisherPublished = () => {
        console.log('[OpenTok Connected][publisher published]', {
            visitId: this.props.visitId,
            userType: this.props.userType,
            role: this.props.role,
        });
    };

    // Initialize browser speech recognition for in-person sessions
    initializeSpeechRecognition = () => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

        if (!SpeechRecognition) {
            return;
        }

        const recognition = new SpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = true;
        // Caption language must follow the language chosen for this session, not the
        // domain-level app language. Fall back to the domain language (previous behaviour)
        // only when the session did not carry an explicit transcription language.
        const sessionLanguage = String(
            sessionStorage.getItem('SESSION_TRANSCRIPTION_LANGUAGE') || ''
        )
            .trim()
            .toLowerCase();
        const effectiveLanguage = sessionLanguage || AppConfig.appLanguage;
        const lang = effectiveLanguage === 'es' ? 'es-ES' : 'en-US';
        recognition.lang = lang;
        recognition.maxAlternatives = 1;

        // Enhanced management for long sessions (15+ minutes)
        let restartTimeout;
        let isManualRestart = false;
        let sessionStartTime = Date.now();
        let restartCount = 0;

        recognition.onstart = () => {
            this.setState({ isListening: true });
            // Clear any pending restart
            if (restartTimeout) {
                clearTimeout(restartTimeout);
            }
        };

        recognition.onresult = (event) => {
            let finalTranscript = '';
            let interimTranscript = '';

            for (let i = event.resultIndex; i < event.results.length; i++) {
                const transcript = event.results[i][0].transcript;

                if (event.results[i].isFinal) {
                    finalTranscript += transcript;
                } else {
                    interimTranscript += transcript;
                }
            }

            if (finalTranscript.trim()) {
                this.addToSpeechBuffer(finalTranscript.trim());
            }

            if (interimTranscript.trim()) {
                this.setState({ caption: interimTranscript.trim() });
            }

            // Reset restart timer on active speech
            if (restartTimeout) {
                clearTimeout(restartTimeout);
            }
            // Preemptive restart for long speeches (prevent 30s timeout)
            restartTimeout = setTimeout(() => {
                if (this.state.isListening && this.state.event && this.isInPersonSession()) {
                    isManualRestart = true;
                    recognition.stop();
                }
            }, 25000); // Restart before 30s limit
        };

        recognition.onerror = (event) => {
            restartCount++;

            // For long sessions, add progressive delays if too many errors
            const baseDelay = restartCount > 10 ? 200 : 50;

            // Handle errors and ensure restart
            if (event.error !== 'aborted' && this.state.event && this.isInPersonSession()) {
                setTimeout(() => {
                    this.startSpeechRecognition();
                }, baseDelay);
            }
        };

        recognition.onend = () => {
            this.setState({ isListening: false });

            if (restartTimeout) {
                clearTimeout(restartTimeout);
            }

            // Only auto-restart if recognition is still allowed (i.e. not muted)
            if (this.state.event && this.isInPersonSession() && this.state.isRecognitionAllowed) {
                // For very long sessions (>10 minutes), add slight delays to prevent browser strain
                const sessionDuration = Date.now() - sessionStartTime;
                const isLongSession = sessionDuration > 600000; // 10 minutes
                const restartDelay = isManualRestart ? 50 : isLongSession ? 150 : 100;

                setTimeout(() => {
                    isManualRestart = false;
                    this.startSpeechRecognition();
                }, restartDelay);
            }
        };

        // Keep a synchronous handle as well as the state copy: callers that create and
        // then immediately start recognition (the unmute path) would otherwise read a
        // still-null this.state.speechRecognition and silently never start listening,
        // which is exactly how an unmuted in-person session ends up with no captions.
        this.speechRecognitionRef = recognition;
        this.setState({ speechRecognition: recognition });
    };

    // Check if current session is in-person
    isInPersonSession = () => {
        const visitType = store.get('VISIT_TYPE');
        const sessionType = sessionStorage.getItem('SESSION_TYPE');
        return visitType === 'one_to_one' && sessionType === 'IN_PERSON';
    };

    // Convert our own raw OpenTok audio level (0-1, non-linear) into a smoothed,
    // perceptual value and decide whether the host is speaking. Same moving-average +
    // logarithmic scaling used for remote participants.
    handleSelfAudioLevel = (audioLevel) => {
        // Only in-person sessions show this highlight, and only while the mic is live.
        if (!this.isInPersonSession()) {
            return;
        }
        if (this.state.isAudioMuted) {
            this.clearSelfSpeaking();
            return;
        }

        const level = typeof audioLevel === 'number' ? audioLevel : 0;
        let avg = this.selfAudioAverage;
        if (avg == null || avg <= level) {
            avg = level;
        } else {
            avg = 0.7 * avg + 0.3 * level;
        }
        this.selfAudioAverage = avg;

        let logLevel = Math.log(avg) / Math.LN10 / 1.5 + 1;
        logLevel = Math.min(Math.max(logLevel, 0), 1);

        if (logLevel > SELF_SPEAKING_THRESHOLD) {
            this.markSelfSpeaking();
        } else {
            this.scheduleClearSelfSpeaking();
        }
    };

    // Turn the highlight on right away and cancel any pending "off".
    markSelfSpeaking = () => {
        if (this.selfSpeakingOffTimer) {
            clearTimeout(this.selfSpeakingOffTimer);
            this.selfSpeakingOffTimer = null;
        }
        if (!this.state.isSelfSpeaking) {
            this.setState({ isSelfSpeaking: true });
        }
    };

    // Turn it off after a short pause so it does not flicker between words.
    scheduleClearSelfSpeaking = () => {
        if (!this.state.isSelfSpeaking || this.selfSpeakingOffTimer) {
            return;
        }
        this.selfSpeakingOffTimer = setTimeout(() => {
            this.selfSpeakingOffTimer = null;
            this.clearSelfSpeaking();
        }, SELF_SPEAKING_OFF_DELAY);
    };

    clearSelfSpeaking = () => {
        if (this.selfSpeakingOffTimer) {
            clearTimeout(this.selfSpeakingOffTimer);
            this.selfSpeakingOffTimer = null;
        }
        this.selfAudioAverage = null;
        if (this.state.isSelfSpeaking) {
            this.setState({ isSelfSpeaking: false });
        }
    };

    // Start speech recognition
    startSpeechRecognition = () => {
        const speechRecognition = this.speechRecognitionRef || this.state.speechRecognition;

        if (speechRecognition && !this.state.isListening) {
            try {
                speechRecognition.start();
            } catch (error) {
                // start() throws if it is already running - harmless, but anything else
                // means we are not listening and would lose every caption silently.
                if (error?.name !== 'InvalidStateError') {
                    console.error('[InPerson][captions] speech recognition failed to start', {
                        name: error?.name,
                        message: error?.message,
                    });
                }
            }
        }
    };

    // Stop speech recognition
    stopSpeechRecognition = () => {
        const speechRecognition = this.speechRecognitionRef || this.state.speechRecognition;
        if (speechRecognition && this.state.isListening) {
            speechRecognition.stop();
            this.setState({ isListening: false });
        }
    };

    // Add speech to buffer and manage emission timing
    addToSpeechBuffer = (speechChunk) => {
        const currentTime = Date.now();
        this.setState((prevState) => {
            // Prevent memory issues in long sessions - limit buffer size
            const currentBuffer = prevState.speechBuffer || '';
            const newBuffer = currentBuffer ? `${currentBuffer} ${speechChunk}` : speechChunk;

            // If buffer gets too long (>500 chars), process immediately to prevent memory buildup
            if (newBuffer.length > 500) {
                // Process current buffer first
                setTimeout(() => {
                    this.handleSpeechCaption(currentBuffer.trim());
                }, 0);

                // Start new buffer with current chunk
                return {
                    speechBuffer: speechChunk,
                    lastSpeechTime: currentTime,
                };
            }

            return {
                speechBuffer: newBuffer,
                lastSpeechTime: currentTime,
            };
        });

        // Clear existing timeout
        if (this.speechBufferTimeout) {
            clearTimeout(this.speechBufferTimeout);
        }

        // Set timeout to process buffer after speech pause
        this.speechBufferTimeout = setTimeout(() => {
            this.processSpeechBuffer();
        }, 1500); // Wait 1.5 seconds after last speech chunk
    };

    // Process accumulated speech buffer
    processSpeechBuffer = () => {
        const { speechBuffer } = this.state;

        if (!speechBuffer || speechBuffer.trim().length < 2) {
            return;
        }
        // Emit the complete speech
        this.handleSpeechCaption(speechBuffer.trim());
        // Clear the buffer
        this.setState({
            speechBuffer: '',
            lastSpeechTime: null,
        });
    };

    // Handle speech-based caption
    handleSpeechCaption = (transcript) => {
        if (!transcript || transcript.length < 2) return;

        // Guard: Don't emit captions if audio is muted
        if (this.state.isAudioMuted) {
            return;
        }

        this.setState({ caption: transcript });
        if (this.captionTimeout) {
            clearTimeout(this.captionTimeout);
        }
        this.captionTimeout = setTimeout(() => {
            this.setState({ caption: null });
        }, 5000);
        const userInfo = {
            caption: transcript,
            sessionId: this.props.visitId,
            streamId: this.state.event?.stream?.id,
            isFinal: true,
            userId: this.getCorrectUserId(),
        };

        if (!userInfo.streamId) {
            // The publisher never got a stream, so the server has nothing to map this
            // caption back to. Worth shouting about - this is a silent transcript loss.
            console.warn('[InPerson][captions] emitting caption with no streamId', {
                visitId: this.props.visitId,
                userId: userInfo.userId,
            });
        }

        emitLiveCaption(userInfo);
        
        // Count total users (regular + anonymous)
        const myUserId = this.getCurrentUserId();
        const sessionUsersCount = this.props.studentDetails?.sessionUsers?.filter(u => u.userId !== myUserId).length || 0;
        const externalUsersCount = this.props.studentDetails?.externalUsersDetails?.length || 0;
        const hasOtherUsers = (sessionUsersCount + externalUsersCount) > 0;
        
        if (hasOtherUsers) {
            this.announceMyStreamId(this.state.event?.stream?.id);
        }
    };

    getCurrentUserId = () => {
        const userSession = store.get('userSession');
        const insAdminSession = store.get('insAdminSession');
        const urlParams = new URLSearchParams(window.location.search);
        const urlUserId = urlParams.get('userId');

        if ((this.props.hasUrlParams || urlParams.get('socketAuthentication')) && urlUserId) {
            return urlUserId;
        }

        return (
            this.props.userId ||
            urlUserId ||
            store.get('bloomIfAI_id') ||
            userSession?.id ||
            insAdminSession?.id ||
            null
        );
    };

    resolveTargetUserId = () => {
        const sessionType = sessionStorage.getItem('SESSION_TYPE');
        const myUserId = this.getCurrentUserId();
        const urlParams = new URLSearchParams(window.location.search);
        const createdByUserId = urlParams.get('createdByUserId');
        
        // Try to get user data from studentDetails (sessionUsers/externalUsersDetails)
        const studentDetails = this.props.studentDetails;
        if (studentDetails) {
            // Check sessionUsers first
            if (studentDetails.sessionUsers && Array.isArray(studentDetails.sessionUsers)) {
                const otherUser = studentDetails.sessionUsers.find(user => user.userId !== myUserId);
                if (otherUser?.userId) {
                    return otherUser.userId;
                }
            }
            // Then check externalUsersDetails
            if (studentDetails.externalUsersDetails && Array.isArray(studentDetails.externalUsersDetails)) {
                const otherUser = studentDetails.externalUsersDetails.find(user => user.userId !== myUserId);
                if (otherUser?.userId) {
                    return otherUser.userId;
                }
            }
        }

        // Fallback to existing logic
        if (sessionType === 'IN_PERSON') {
            return this.props.calldoctorUserId || this.props.callpatientUserId || myUserId;
        }

        if (this.props.role === 'DOCTOR') {
            if (this.props.callpatientUserId === myUserId) {
                return this.props.calldoctorUserId || this.props.callpatientUserId || myUserId;
            }
            return this.props.callpatientUserId || this.props.calldoctorUserId || myUserId;
        }

        if (createdByUserId && createdByUserId !== myUserId) {
            return createdByUserId;
        }
        if (this.props.callpatientUserId && this.props.callpatientUserId !== myUserId) {
            return this.props.callpatientUserId;
        }
        if (this.props.calldoctorUserId && this.props.calldoctorUserId !== myUserId) {
            return this.props.calldoctorUserId;
        }

        return (
            createdByUserId ||
            this.props.callpatientUserId ||
            this.props.calldoctorUserId ||
            myUserId
        );
    };

    // Get correct user ID based on session type
    getCorrectUserId = () => {
        // Publisher always uses its own userId, not target user
        return this.getCurrentUserId();
    };

    announceMyStreamId = (streamId) => {
        if (!streamId) {
            return;
        }

        const userId = this.getCurrentUserId();
        const streamData = {
            streamId,
            userId,
            isPublisherStream: true,
        };

        emitStreamId(streamData);

        if (this.props.session && typeof this.props.session.signal === 'function') {
            this.props.session.signal(
                {
                    type: 'streamIdMapping',
                    data: JSON.stringify({ streamId, userId }),
                },
                (err) => {
                    if (err) {
                        console.warn('[Publisher] Failed to signal streamIdMapping', err);
                    }
                }
            );
        }
    };
    
    // Called when new user joins - re-emit stream ID
    emitMyStreamId = () => {
        const { event } = this.state;
        
        // Count total users (regular + anonymous)
        const myUserId = this.getCurrentUserId();
        const sessionUsersCount = this.props.studentDetails?.sessionUsers?.filter(u => u.userId !== myUserId).length || 0;
        const externalUsersCount = this.props.studentDetails?.externalUsersDetails?.length || 0;
        const hasOtherUsers = (sessionUsersCount + externalUsersCount) > 0;
        const shouldEmit =
            hasOtherUsers ||
            this.props.sessionTypeParamsGroup ||
            this.props.isClassRoom ||
            this.props.isConferenceCall;
        
        if (shouldEmit && event?.stream?.id) {
            this.announceMyStreamId(event.stream.id);
        }
    };

    // Method to handle our own captions received via session-level events
    handleOwnCaption = (event) => {
        const caption = event.caption;
        this.setState({ caption });
        
        // Clear existing timeout to prevent multiple emissions
        if (this.captionTimeout) {
            clearTimeout(this.captionTimeout);
        }
        
        this.captionTimeout = setTimeout(() => {
            this.setState({ caption: null });
        }, 3000);

        const userInfo = {
            caption: caption,
            sessionId: this.props.visitId,
            streamId: event.streamId,
            isFinal: event.isFinal,
            userId: this.getCurrentUserId(), // Publisher always uses own userId
        };

        this.logStreamAndUserId(event);

        setTimeout(() => {
            emitLiveCaption(userInfo);
        }, 2000);
    };

    handleCaptionReceived = (event) => {
        const caption = event.caption;
        this.setState({ caption });
        
        // Clear existing timeout to prevent multiple emissions
        if (this.captionTimeout) {
            clearTimeout(this.captionTimeout);
        }
        
        const userInfo = {
            caption: caption,
            sessionId: this.props.visitId,
            streamId: event.streamId,
            isFinal: event.isFinal,
            userId: this.getCurrentUserId(), // ✅ CRITICAL: Publisher must include own userId!
        };
        
        this.logStreamAndUserId(event);
        
        this.captionTimeout = setTimeout(() => {
            emitLiveCaption(userInfo);
        }, 2000);
    };

    logStreamAndUserId = (event) => {
        // Publisher emits its own userId, not target user
        // (resolveTargetUserId fails in multi-user sessions by returning first other user)
        this.announceMyStreamId(event.streamId);
    };

    //publisherEventHandlersScreen
    publisherEventHandlersScreen = {
        accessDenied: () => {
            this.setState({ screenShare: false });
            this.cancelScreenshare(false);
            alert(this.props.t('screenShareCancelled'));
        },
        mediaStopped: () => {
            this.setState({ screenShare: false });
            this.cancelScreenshare(false);
        },
        streamCreated: (event) => {
            if (event.stream.videoType === 'screen') {
                this.cancelScreenshare(true);
                if (this.props.isBroadCast) {
                    this.props.streamLayoutBroadCast(event.stream.id);
                }
            }
        },
        streamDestroyed: (event) => {
            this.setState({ screenShare: false });
            this.cancelScreenshare(false);
            if (this.props.isBroadCast) {
                this.props.streamLayoutBroadCast(event.stream.id);
            }
        },
    };

    render() {
        // this.publisherOptions.videoFilter = {
        //     type: 'backgroundReplacement',
        //     backgroundImgUrl: BG_IMAGE,
        // };

        const getSafePublisherProperties = () => {
            const properties = {
                ...this.publisherOptions,
                publishCaptions: true,
            };

            const { videoFilter } = properties;

            // Guard against invalid filter payloads so publisher init never fails.
            if (videoFilter?.type === 'backgroundReplacement' && !videoFilter?.backgroundImgUrl) {
                delete properties.videoFilter;
            }

            return properties;
        };

        const safePublisherProperties = getSafePublisherProperties();

        const { streams } = { ...this.props };
        const showStudents = streams.find((e) => e.name !== 'Educator');
        const isAnyoneScreenSharing = streams?.some((stream) => stream.videoType === 'screen');

        const isSplitView = this.props.fullScreenEnabled && isAnyoneScreenSharing;

        const shouldShowBud =
            this.props.fullScreenEnabled || this.props.isOneToOne || this.props.sessionTypeParams;

        // In-person sessions highlight the local tile while the host is talking.
        const isSelfSpeaking = this.isInPersonSession() && this.state.isSelfSpeaking;

        const shouldHideBothForOneToOne =
            this.props.fullScreenEnabled &&
            isAnyoneScreenSharing &&
            (this.props.isOneToOne || this.props.sessionTypeParams);

        return (
            <div>
                {store.get('VISIT_TYPE') === 'broadcast' && this.props.role === Doctor ? (
                    <div className="parent-div">
                        {!showStudents && this.props.renderLogoWithWifi()}
                        <div
                            className="classroom-video broadcast-user"
                            style={{ backgroundColor: 'black' }}
                        >
                            {this.props.isWhiteboardOpen ? (
                                <>
                                    <ScreenShotEditModal visitId={this.props.visitId} />

                                    <BroadCastSubscribers
                                        sessionHelper={this.props.sessionHelper}
                                        streams={this.props.streams}
                                        renderLogoWithWifi={this.props.renderLogoWithWifi}
                                        showStudents={showStudents}
                                    />
                                </>
                            ) : (
                                <>
                                    <BroadCastSubscribers
                                        sessionHelper={this.props.sessionHelper}
                                        streams={this.props.streams}
                                        renderLogoWithWifi={this.props.renderLogoWithWifi}
                                        showStudents={showStudents}
                                    />
                                </>
                            )}
                            <div
                                style={{
                                    height: showStudents ? '80%' : '100%',
                                    paddingTop: showStudents ? '4px' : '',
                                }}
                                className="w-full"
                            >
                                <div
                                    className={`${
                                        !showStudents ? 'classroom-video' : 'h-full'
                                    } broadcast-video  ${
                                        (this.props.showMessagePop ||
                                            this.props.showParticipants ||
                                            this.props.messageClicked) &&
                                        this.props.minWidth
                                            ? 'z-index-minus-1'
                                            : 'z-index-1'
                                    }`}
                                >
                                    {this.props.isWhiteboardOpen && (
                                        <ScreenShotEditModal visitId={this.props.visitId} />
                                    )}
                                    <OTPublisher
                                        session={this.props.session}
                                        properties={safePublisherProperties}
                                        eventHandlers={this.publisherEventHandlers}
                                        onError={this.handlePublisherError}
                                        onPublish={this.handlePublisherPublished}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        {/* ================= LEFT SIDE (BUD) ================= */}
                        {isSplitView && shouldShowBud && (
                            <aside
                                className={`absolute bottom-[10%] left-[1%] flex items-end z-10 
                            ${shouldHideBothForOneToOne ? 'opacity-0 pointer-events-none' : ''}`}
                            >
                                <div className="relative w-[137.95px] h-[137.95px] rounded-[6px] border border-[#34373E] shadow overflow-hidden bg-[#181B22]">
                                    <div className="absolute top-[10px] left-[10px] bg-[#755FDC99] text-white px-2 py-1 rounded text-sm">
                                        {this.props.t('bud').toUpperCase()}
                                    </div>
                                    <img
                                        src={BudImage}
                                        alt="Bud"
                                        className="object-cover w-full h-full p-4 pt-6 pb-0"
                                    />
                                </div>
                            </aside>
                        )}

                        {/* ================= RIGHT SIDE (YOU + BUD) ================= */}
                        <aside
                            className={`absolute bottom-[10%] right-[1%] flex gap-4 items-end z-10
                        ${shouldHideBothForOneToOne ? 'opacity-0 pointer-events-none' : ''}`}
                        >
                            {/* BUD (only when NOT split) */}
                            {shouldShowBud && !isSplitView && (
                                <div
                                    className={`relative w-[137.95px] h-[137.95px] rounded-[6px] border-[0.65px] border-[#34373E] shadow-[0px_3.03px_37.75px_0px_#00000066] overflow-hidden bg-[#181B22] ${
                                        this.props.showMessagePop ||
                                        this.props.showParticipants ||
                                        this.props.messageClicked
                                            ? 'z-index-minus-1'
                                            : 'z-index-1'
                                    }`}
                                >
                                    <div className="absolute top-[10px] left-[10px] bg-[#755FDC99] text-white px-2 py-1 rounded text-sm font-medium z-10">
                                        {this.props.t('bud').toUpperCase()}
                                    </div>
                                    <img
                                        src={BudImage}
                                        alt="Bud"
                                        className="object-cover w-full h-full p-4 pt-6 pb-0"
                                    />
                                </div>
                            )}

                            {/* ✅ YOU (always visible) */}
                            <div
                                className={`relative w-[137.95px] h-[137.95px] rounded-[6px] border-[0.65px] ${
                                    isSelfSpeaking ? 'border-[#22c55e]' : 'border-[#34373E]'
                                } overflow-hidden ${
                                    this.props.showMessagePop ||
                                    this.props.showParticipants ||
                                    this.props.messageClicked
                                        ? 'z-index-minus-1'
                                        : 'z-index-1'
                                }`}
                                style={{
                                    boxShadow: isSelfSpeaking
                                        ? '0 0 0 2px #22c55e, 0px 3.03px 37.75px 0px #00000066'
                                        : '0px 3.03px 37.75px 0px #00000066',
                                }}
                            >
                                {isSelfSpeaking && (
                                    <style>{`
                                        .publisher-speaking-indicator {
                                            display: inline-flex;
                                            align-items: center;
                                            gap: 2px;
                                            height: 12px;
                                        }
                                        .publisher-speaking-indicator .publisher-speaking-bar {
                                            width: 3px;
                                            height: 100%;
                                            background-color: #ffffff;
                                            border-radius: 2px;
                                            transform: scaleY(0.35);
                                            transform-origin: center;
                                            animation: publisherSpeakingBar 0.9s ease-in-out infinite;
                                        }
                                        .publisher-speaking-indicator .publisher-speaking-bar:nth-child(2) {
                                            animation-delay: 0.15s;
                                        }
                                        .publisher-speaking-indicator .publisher-speaking-bar:nth-child(3) {
                                            animation-delay: 0.3s;
                                        }
                                        @keyframes publisherSpeakingBar {
                                            0%, 100% { transform: scaleY(0.35); }
                                            50% { transform: scaleY(1); }
                                        }
                                    `}</style>
                                )}
                                <div
                                    className={`absolute top-[10px] left-[10px] ${
                                        isSelfSpeaking ? 'bg-[#22c55ECC]' : 'bg-[#755FDC99]'
                                    } text-white px-2 py-1 rounded text-sm font-medium z-10 flex items-center gap-1.5`}
                                >
                                    {this.props.t('you').toUpperCase()}
                                    {isSelfSpeaking && (
                                        <span className="publisher-speaking-indicator">
                                            <span className="publisher-speaking-bar"></span>
                                            <span className="publisher-speaking-bar"></span>
                                            <span className="publisher-speaking-bar"></span>
                                        </span>
                                    )}
                                </div>
                                <div className="transform scale-x-[-1]">
                                    <OTPublisher
                                        session={this.props.session}
                                        properties={safePublisherProperties}
                                        eventHandlers={this.publisherEventHandlers}
                                        onError={this.handlePublisherError}
                                        onPublish={this.handlePublisherPublished}
                                    />
                                </div>
                            </div>
                        </aside>
                    </>
                )}

                {/* ================= SCREEN SHARE ================= */}
                {this.state.screenShare &&
                (store.get('VISIT_TYPE') === 'class_room' ||
                    store.get('VISIT_TYPE') === 'conference_call' ||
                    this.props.sessionTypeParamsGroup ||
                    this.props.OwnerAsCollaborator ||
                    this.props.role === Doctor ||
                    this.props.userType === Student) ? (
                    <div className="my-video-screen z-index-1">
                        <OTPublisher
                            session={this.props.session}
                            properties={{
                                ...this.publisherOptionscreen,
                                publishCaptions: true,
                            }}
                            eventHandlers={this.publisherEventHandlersScreen}
                        />
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

const ConnectedOpentokPublisher = withLanguage(OpentokPublisher);

// Export with LanguageProvider and ref forwarding
export default React.forwardRef((props, ref) => (
    <LanguageProvider>
        <ConnectedOpentokPublisher {...props} ref={ref} />
    </LanguageProvider>
));
